import './css/styles.scss';

function infoListaInit() {}

infoListaInit();
